import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const fetchReviews = createAsyncThunk(
   'reviews/fetchReviews',
   async (url, thunkAPI) => {
      const limit = 5
      const entities = thunkAPI.getState().reviews.entities[url]
      const page = entities ? entities.reviews.length / limit + 1 : 1
      try {
         const response = await API.get(`/reviews`, { params: { url, page, limit } })
         return response.data
      } catch (err) {
         thunkAPI.dispatch(setError({ action: 'fetchReviews', code: err.response.status, message: err.message }))
         return thunkAPI.rejectWithValue()
      }
   },
   {
      condition: (url, { getState }) => {
         const { reviews } = getState()
         if (reviews.status[url] === 'loading') return false
         if (reviews.entities[url] && reviews.entities[url].reviews.length === reviews.entities[url].count) {
            return false
         }
      }
   }
)

const initialState = {
   entities: {},
   status: {}
}

const reviewsSlice = createSlice({
   name: 'reviews',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchReviews.pending, (state, action) => {
         const url = action.meta.arg
         state.status[url] = state.entities[url] ? 'loading' : 'init'
      })
      builder.addCase(fetchReviews.fulfilled, (state, action) => {
         const url = action.meta.arg
         const { reviews: newRevs, ...rest } = action.payload

         const reviews = state.entities[url]?.reviews || []
         reviews.push(...newRevs)
         state.entities[url] = { reviews, ...rest }

         state.status[url] = 'success'
      })
      builder.addCase(fetchReviews.rejected, (state, action) => {
         const url = action.meta.arg
         state.status[url] = 'error'
      })
   }
})

export const reviews = reviewsSlice.reducer
